import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { server } from "../../Constants";
import { Site } from "../../types/site.type";
import { httpClient } from "../../utils/httpclient";
import { RootState } from "../store";


type SiteState = {
    result: Site[];
    message: string;
    isFetching: boolean;
    isError: boolean;
}

const initialStateValues: SiteState = {
    result: [],
    message: "",
    isFetching: false,
    isError: false,
};


export const siteGetData = createAsyncThunk(
    "site/getSites",
    async (keyword: string, thunkApi) => {
        try {
            const result = await httpClient.get<Site[]>(server.SITE_URL + "?keyword=" + keyword);
            return result;
        } catch (error: any) {
            let err = error.response.data.message ?? error.message
            return thunkApi.rejectWithValue(err);
        }
    }
);



const siteSlice = createSlice({
    name: "site",
    initialState: initialStateValues,
    reducers: {},
    extraReducers: (builder) => {
        //async
        builder
            .addCase(siteGetData.pending, (state, action) => {
                state.result = [];
                state.message = "Loading...";
                state.isFetching = true;
                state.isError = false;
            })
            .addCase(siteGetData.fulfilled, (state, action: PayloadAction<any>) => {
                state.result = action!.payload.data;
                state.message = "Success";
                state.isFetching = false;
                state.isError = false;
            })
            .addCase(siteGetData.rejected, (state, action: PayloadAction<any>) => {
                state.result = [];
                state.message = action.payload;
                state.isFetching = false;
                state.isError = true;
            });

    }
})


export const { } = siteSlice.actions;
export const siteSelector = (store: RootState) => store.siteReducer;
export default siteSlice.reducer;